import type { ReactNode } from "react";

import type { CancellableWorkdayStatus } from "@lib/store/src/data/timeslots/apiTypes";
import { WorkdayIcon } from "@molecules";

type PersonWorkdayTileProps = {
  status: CancellableWorkdayStatus;
  title: string;
  subtitle: string;
  children?: ReactNode;
};

export const PersonWorkdayTile = ({ status, title, subtitle, children }: PersonWorkdayTileProps) => {
  return (
    <div className="flex flex-col gap-4 rounded-xl border bg-beige-100 p-4">
      <div className="flex items-center gap-4">
        <WorkdayIcon
          status={status}
          className="flex-none bg-energizing-yellow-500*"
        />

        <div className="flex min-w-0 flex-col">
          <p className="truncate font-semibold">{title}</p>
          <p className="text-mapiq-black-500">{subtitle}</p>
        </div>
      </div>

      {children}
    </div>
  );
};
